import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminPhotosReview from "@/pages/admin/AdminPhotosReview";

export const Route = createFileRoute("/admin/photos/review/")({
  head: () => pageHead("Admin \u2014 Photos \u2014 Review \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminPhotosReview,
});
